import StringUtils from '../utils/StringUtils';

export default function ErrorFlag(props) {
  return (
    <span
      className="pwx-error-flag dx-icon-warning"
      hidden={!StringUtils.isNonEmptyString(props.errorProperty)}
      title={props.errorProperty}
    />
  );
}